































import { random } from "lodash";
import { Vue, Component } from "vue-property-decorator";
import PeriodComparator from "./PeriodComparator.vue";

@Component({ components: { PeriodComparator } })
export default class SummaryTable extends Vue {
  columns = ["homepage", "insidepage", "newsletter", "top5"];

  getRandomFor(col: string): number | undefined {
    switch (col) {
      case "homepage":
        return random(0, 100);
      case "insidepage":
        return random(51, 100);
      case "newsletter":
        return undefined;
      case "top5":
        return 0;
      default:
        return undefined;
    }
  }

  headers = [
    {
      text: "País / Ambiente",
      align: "start",
      sortable: false,
      value: "name",
    },
    { text: "Homepage (%)", align: "end", value: "homepage" },
    { text: "Inside Page (%)", align: "end", value: "insidepage" },
    { text: "Newsletter (%)", align: "end", value: "newsletter" },
    { text: "Top 5 (%)", align: "end", value: "top5" },
  ];

  rows = [
    {
      name: "Chile",
      homepage: random(0, 100),
      insidepage: random(0, 50),
      newsletter: random(0, 100),
      top5: random(0, 100),
    },
    {
      name: "Perú",
      homepage: random(0, 100),
      insidepage: random(0, 50),
      newsletter: random(0, 100),
      top5: random(0, 100),
    },
    {
      name: "México",
      homepage: random(0, 100),
      insidepage: random(0, 50),
      newsletter: 23,
      top5: 6.0,
    },
    {
      name: "Argentina",
      homepage: random(0, 100),
      insidepage: 3.7,
      newsletter: 67,
      top5: 0,
    },
  ];
}
